import { render, staticRenderFns } from "./selectedProduct.vue?vue&type=template&id=c2c26de0&"
import script from "./selectedProduct.vue?vue&type=script&lang=js&"
export * from "./selectedProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports